import { scoreColor } from "@/lib/api";
import { AlertTriangle, Loader2 } from "lucide-react";

/**
 * ScoreBadge — renders one of:
 *  - 0-100 numeric match score with semantic color
 *  - "scoring…" amber pulse when AI scoring is in flight
 *  - "AI paused" amber chip when AI is unavailable (budget/rate/provider down).
 *    Recruiter can click Retry from the dedicated row chip to re-run.
 */
export default function ScoreBadge({ score, size = "md", processing = false, status = null }) {
    const s = Math.max(0, Math.min(100, Math.round(score || 0)));
    const dim = size === "lg" ? "text-2xl px-4 py-2" : size === "sm" ? "text-xs px-2 py-1" : "text-sm px-3 py-1";

    if (status === "ai_unavailable" || status === "ai_paused") {
        return (
            <span
                data-testid="score-ai-unavailable"
                className={`inline-flex items-center font-mono font-bold border border-amber-300 bg-amber-50 text-amber-800 ${dim}`}
                title="AI scoring paused — retry once credits/service restored"
            >
                <AlertTriangle className="w-3 h-3 mr-1" />
                <span className="text-[10px] uppercase tracking-widest">AI paused</span>
            </span>
        );
    }

    if (processing) {
        return (
            <span
                data-testid="score-processing"
                className={`inline-flex items-center font-mono font-bold border border-amber-300 bg-amber-50 text-amber-800 ${dim}`}
                title="Scoring in progress"
            >
                <Loader2 className="w-3 h-3 mr-1 animate-spin" />
                <span className="opacity-70 text-[10px]">scoring…</span>
            </span>
        );
    }
    return (
        <span
            data-testid={`score-${s}`}
            className={`inline-flex items-center font-mono font-bold border ${scoreColor(s)} ${dim}`}
        >
            {s}
            <span className="opacity-50 ml-0.5 text-[10px]">/100</span>
        </span>
    );
}
